import React, { useContext } from 'react';
import './congratulationsPage.css';
import strings from '../../utils/property-file/congratulationsPage.json';
import { useNavigate } from 'react-router-dom';
import constants from '../../utils/constants';
import { FormContext } from '../formContext';
import { AdminFormContext } from '../adminFormContext';
import { ImageContext } from '../adminProfilePhotoContext';
import { OfficeFormContext } from '../officeFormContext';

export default function CongratulationsPage() {

    const nav = useNavigate()
    let companyName = localStorage.getItem('companyName')
    localStorage.removeItem("newSession");
    const { setFormData, setAddress } = useContext(FormContext);
    const { setAdminFormData } = useContext(AdminFormContext);
    const { setImageData } = useContext(ImageContext);
    const { setOfficeFormData } = useContext(OfficeFormContext);
    setFormData('');
    setAddress('');
    setAdminFormData('');
    setImageData(null);
    setOfficeFormData({})
    setTimeout(() => {
        nav(constants.navigationLink.loginLink)
    }, 3000)

    return (
        <div className="parent-admin-container">
            <div className="child-container">
                <div className="img-fluid check-box">
                    <i className="ri-check-line"></i>
                    <div className="congratulation-heading">
                        <h1>{strings.heading}</h1>
                        <p>{strings.subHeading} <u>{companyName}</u></p>
                    </div>
                </div>

            </div>
        </div>
    )
}